import { Link } from 'react-router-dom';
import { AppendScript } from '../../constants/appendScript'
import React, { useEffect } from "react";
import { baseUrl } from '../../constants/constants'

export const Header = () => {

    useEffect(() => {
        AppendScript(baseUrl + "assets/js/custom.js");
    }, []);
    return (
        <header className="position_top">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col col-sm-3 col-md-3 col-lg-3 col-xl-2">
                        <div className="logo">
                            <a href="/"><img src="assets/img/logo.png" alt="" /></a>
                        </div>
                    </div>
                    <div className="col col-sm-5 col-md-6 col-lg-6 col-xl-8 text-end">
                        <nav className="main-nav" id="mMenu">
                            <div className="mobile-menu-logo">
                                <a href="/"><img src="assets/img/logo-white.png" alt="" /></a>
                            </div>
                            <ul>
                                <li className="has-child">
                                    <a href="#services" role="button" aria-expanded="false">Services</a>
                                    <i className="bi bi-chevron-down"></i>
                                    <ul className="sub-menu">
                                        <li><a href="/web-app-development">Web App Development</a></li>
                                        <li><a href="/mobile-app-development">Mobile App Development</a></li>
                                        <li><a href="/ecommerce-solutions">Ecommerce Solutions</a></li>
                                        <li><a href="/digital-marketing">Digital Marketing</a></li>
                                    </ul>
                                </li>
                                <li className="has-child"><a href='/about'>About</a></li>
                                {/* {{-- < li > <Link to={'/works">Works</a></li> --}} */}
                                <li disabled className="has-child"><Link to={'##'}>Careers</Link></li>
                                <li><a href='/contact'>Contact</a></li>
                            </ul>
                            <div className="get-quate dn">
                                <div className="cmn-btn">
                                    <a href='/contact'>Get a quote</a>
                                </div>
                            </div>
                        </nav>
                        <div className="mobile-menu">
                            <button className="cross-btn" style={{background: 'transparent'}}>
                                <span className="cross-top"></span>
                                <span className="cross-middle"></span>
                                <span className="cross-bottom"></span>
                            </button>
                        </div>
                    </div>
                    <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-2 text-end">
                        <div className="get-quate">
                            <div className="cmn-btn">
                                <a href='/contact'>Get a quote</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </header>
    )
}
// export default Header;